<template>
  <div class="my-3">
    <label :for="id" class="mb-1 font-medium block text-dark-600 dark:text-dark-50">{{ label }}
      <span v-if="required" class="text-red-500">*</span>
    </label>
    <div class="flex flex-wrap gap-4">
      <div v-for="(item, index) in options" :key="index" class="flex items-center gap-2">
        <RadioButton v-model="displayValue" :input-id="(index+'_'+name)" :name="name" :value="item.value" :checked="displayValue === item.value" />
        <label :for="(index+'_'+name)" class="text-dark-600 dark:text-dark-50">{{ item.label }}</label>
      </div>
    </div>
    <Message v-if="!valid" size="small" severity="error" variant="simple">{{ errorMessage }}
    </Message>
  </div>
</template>

<script>
import { Message, RadioButton } from 'primevue';

export default {
  name: 'InputRadio',
  props: {
    label: {
      type: String,
      required: true
    },
    name: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: 'Pilih opsi'
    },
    options: {
      type: Array,
      required: true
    },
    modelValue: {
      type: [String, Number],
      default: ''
    },
    valid: {
      type: Boolean,
      default: true
    },
    errorMessage: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Message, RadioButton
  },
  data() {
    return {
      displayValue: this.modelValue
    }
  },
  watch: {
    displayValue(newValue) {
      this.$emit('update:modelValue', newValue);
    },
    modelValue(newValue) {
      this.displayValue = newValue;
    }
  },
  emits: ['update:modelValue']
}
</script>